<template>
  <div id="auditable-entity-container" class="card">
    <div class="card-body">
      <h6>Audit Fields</h6>
      <ul>
        <!-- <Only Used by the EditTasks Modal> -->
        <li v-if="data.assignedAt"><strong>Assigned on: </strong>{{ data.assignedAt | formatDate }}</li>
        <li v-if="data.assignedBy"><strong>Assigned by: </strong>{{ displayUser(data.assignedBy) }}</li>
        <!-- </Only Used by the EditTasks Modal> -->

        <li><strong>Created on: </strong>{{ data.createdAt | formatDate }}</li>
        <li><strong>Created by: </strong>{{ displayUser(data.createdBy)}}</li>
        <li v-if="data.updatedAt"><strong>Last Updated on: </strong>{{ data.updatedAt | formatDate }}</li>
        <li v-if="data.updatedAt"><strong>Last Updated by: </strong>{{ displayUser(data.updatedBy) }}</li>
      </ul>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  props: ['data'],
  computed: {
    ...mapGetters({
      users: 'users/resultsMap'
    })
  },
  methods: {
    displayUser(userId) {
      const user = this.users[userId]
      if (user) {
        return user
      }
      return userId
    }
  }
}
</script>

<style scoped>
  #auditable-entity-container {
    margin-top: 20px;
  }
</style>
